import { ClassNameConsumer } from 'app/_utils/styled/ClassNameConsumer';

import { Popover, Avatar } from 'antd';
import styled from 'styled-components';

export const AccountActions = styled.div`
  display: flex;
  align-items: center;

  > *:not(:last-child) {
    margin-right: 12px;
  }
`;

export const PopoverWrap = styled(ClassNameConsumer)`
  .ant-popover-arrow {
    right: 7px !important;
  }

  .ant-popover-arrow::before {
    background: #008080;
  }

  .ant-popover-title {
    align-items: center;
    background-color: #008080;
    color: white;
    display: flex;
    font-size: 15px;
    height: 45px;
    padding: 0 16px;
  }

  .ant-popover-content {
    --text-color: rgba(0, 0, 0, 0.85); /* match Stream, in here and Dropdown */
  }

  .ant-popover-inner-content {
    color: var(--text-color);
    padding: 0;
  }
`;

export const AccountPopover = styled(Popover)`
  cursor: pointer;
`;

export const UserIconWrapper = styled.div`
  margin-right: 16px;
  margin-left: 4px;
  padding: 4px;
  border-radius: 4px;
  &:hover {
    background: #ced9e0;
  }
`;

export const StyledAvatar = styled(Avatar)`
  background: #008080;
  vertical-align: middle;
`;
